import { render, staticRenderFns } from "./EmDictTypeList.vue?vue&type=template&id=fcde7dc0&"
import script from "./EmDictTypeList.vue?vue&type=script&lang=js&"
export * from "./EmDictTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports